{
	"title": "block title",
	"description": "block description",
	"keywords": [ "block keyword" ],
	"styles": [
		{
			"label": "block style label"
		}
	],
	"variations": [
		{
			"title": "block variation title",
			"description": "block variation description",
			"keywords": [ "block variation keyword" ]
		}
	]
}
